import styled from 'styled-components';

export const CategorySumupContainer = styled.div`
  display: flex;
  column-gap: 16px;
  padding: ${(props) => (props.isCategoryOpen ? '0px' : '0 0 16px 0')};
  border-bottom: ${(props) => (props.isCategoryOpen ? '0px' : '1px solid #e6e6e6')};
  cursor: pointer;
`;

export const TextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 3;
`;

export const Text = styled.div`
  text-transform: capitalize;
  font: ${(props) => props.theme.fonts.h2Inter} !important;
`;
